import { Component, OnInit, TemplateRef, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import {
  Validators,
  FormBuilder,
  FormGroup,
  FormControl,
} from '@angular/forms';
import { HelpersService } from '../../../shared/servicio/helpers/helpers.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-update-medic',
  templateUrl: './update-medic.component.html',
  styleUrls: ['./update-medic.component.css'],
})
export class UpdateMedicComponent implements OnInit, OnDestroy {
  specialties: any;
  cities: any[] = [];
  departments: any[] = [];
  filteredCities: any[] = [];
  selectedCity: any = null;
  citySearchTerm: string = '';
  showCityDropdown: boolean = false;
  searchTimeout: any = null;
  isSearching: boolean = false;
  update: FormGroup;
  name: FormControl;
  name2: FormControl;
  email: FormControl;
  cell: FormControl;
  dni: FormControl;
  lastname: FormControl;
  lastname_2: FormControl;
  gender: FormControl;
  birthdate: FormControl;
  address: FormControl;
  city: FormControl;
  department: FormControl;
  workplace: FormControl;
  cellphone_validate: boolean;
  submitted = false;
  preloader: boolean = false;
  license: any;
  load: boolean = true;
  modalRef: BsModalRef;
  medicProfile: any = {};

  config = {
    animated: true,
    class: 'modal-dialog-centered modal-app modal-app-sm',
    backdrop: true,
    ignoreBackdropClick: true,
  };

  constructor(
    private _http: HttpClient,
    private formBuilder: FormBuilder,
    public helper: HelpersService,
    private modalService: BsModalService
  ) { }

  ngOnInit() {
    this.updateMedic();
    // Inicializar estados
    this.showCityDropdown = false;
    this.filteredCities = [];
    this.citySearchTerm = '';
    this.loadCities()

    // Cargar ciudades primero, luego la información del usuario
    this.loadCities();
    this.info();
  }

  onCityInputChange(event: any) {
    this.citySearchTerm = event.target.value;

    // Limpiar selección anterior cuando usuario empieza a escribir
    this.selectedCity = null;
    this.shortUpdate.city.setValue('');

    console.log('Usuario escribió:', this.citySearchTerm);
    // Filtrar con lo que acaba de escribir
    this.filterCities();
  }

  updateMedic() {
    this.update = this.formBuilder.group({
      name: [
        null,
        [
          Validators.required,
          Validators.minLength(2),
          Validators.maxLength(100),
          Validators.pattern('[a-zA-ZÀÁÉéÍíÓóÚúÑñ ]*'),
        ],
      ],

      name2: [
        null,
        [
          Validators.minLength(2),
          Validators.maxLength(100),
          Validators.pattern('[a-zA-ZÀÁÉéÍíÓóÚúÑñ]*'),
        ],
      ],

      lastname: [
        null,
        [
          Validators.required,
          Validators.minLength(2),
          Validators.maxLength(100),
          Validators.pattern('[a-zA-ZÀÁÉéÍíÓóÚúÑñ]*'),
        ],
      ],

      lastname_2: [
        null,
        [
          Validators.minLength(2),
          Validators.maxLength(100),
          Validators.pattern('[a-zA-ZÀÁÉéÍíÓóÚúÑñ]*'),
        ],
      ],

      cell: [
        null,
        [
          Validators.required,
          Validators.minLength(10),
          Validators.maxLength(10),
          Validators.pattern(/^\d+$/),
        ],
      ],

      dni: [
        null,
        [
          Validators.required,
          Validators.minLength(5),
          Validators.maxLength(10),
          Validators.pattern(/^\d+$/),
        ],
      ],

      email: [null, [Validators.required, Validators.email]],

      // Campos editables - departamento ya NO se llena automáticamente
      gender: [null, [Validators.required]],
      birthdate: [null, [Validators.required]],
      address: [null, [Validators.required, Validators.minLength(5), Validators.maxLength(200)]],
      city: [null, [Validators.required]],
      department: [null, [Validators.required]], // Ahora ES requerido porque es independiente
      workplace: [null, [Validators.required, Validators.minLength(2), Validators.maxLength(100)]],
    });
  }

  get shortUpdate() {
    return this.update.controls;
  }

  loadCities() {
    // SIEMPRE cargar sin filtro al inicio - sin importar si hay citySearchTerm
    const url = environment.Api_cities_list; // SIN parámetros de búsqueda

    console.log('Loading initial cities without search params:', url);

    this._http.get(url).subscribe(
      (data: any) => {
        this.cities = data.slice(0, 50); // Guardar las primeras 50 ciudades para referencia
        console.log('Initial cities loaded:', this.cities.length);

        // Una vez cargadas las ciudades, cargar el perfil médico adicional
        if (!this.load) {
          this.loadMedicProfile();
        }
      },
      (error) => {
        console.log('Error loading cities:', error);
        this.cities = []; // Asegurar que sea un array vacío
      }
    );
  }

  searchCities(searchTerm: string = '') {
    this.isSearching = true;

    console.log('searchCities recibió:', searchTerm);

    // Solo agregar parámetro search si realmente hay un término de búsqueda nuevo
    let url = environment.Api_cities_list;
    if (searchTerm && searchTerm.trim() !== '' && !searchTerm.includes(' - ')) {
      // Solo buscar si no es un valor ya formateado (que incluye " - ")
      url = `${environment.Api_cities_list}?search=${encodeURIComponent(searchTerm.trim())}`;
    }

    console.log('URL final:', url);

    this._http.get(url).subscribe(
      (data: any) => {
        this.isSearching = false;
        this.filteredCities = data || [];
        this.showCityDropdown = true;
        console.log('Resultados:', this.filteredCities.length);
      },
      (error) => {
        console.log('Error:', error);
        this.isSearching = false;
        this.filteredCities = [];
        this.showCityDropdown = true;
      }
    );
  }

  filterCities() {
    // Limpiar timeout anterior
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }

    // Debounce: esperar 300ms antes de hacer la búsqueda
    this.searchTimeout = setTimeout(() => {
      console.log('Enviando búsqueda con:', this.citySearchTerm);
      this.searchCities(this.citySearchTerm);
    }, 300);
  }

  selectCity(city: any) {
    this.selectedCity = city;
    // Mostrar "Ciudad - Departamento" en el input
    this.citySearchTerm = `${city.dane_id.name} - ${city.dane_id.department_name}`;
    // Guardar el ID para enviar al backend
    this.shortUpdate.city.setValue(city.id);

    this.showCityDropdown = false;
    this.filteredCities = [];
    this.isSearching = false;

    console.log('Ciudad seleccionada - ID:', city.id, 'Display:', this.citySearchTerm);
  }

  onCityInputFocus() {
    // Al hacer focus, solo mostrar dropdown si el usuario realmente quiere buscar
    if (!this.citySearchTerm || this.citySearchTerm.trim() === '') {
      // Si no hay texto, mostrar dropdown vacío
      this.filteredCities = [];
      this.showCityDropdown = true;
    } else if (!this.citySearchTerm.includes(' - ')) {
      // Solo buscar si NO es un valor ya formateado (no incluye " - ")
      this.searchCities(this.citySearchTerm);
    } else {
      // Si es un valor formateado, no buscar automáticamente
      this.filteredCities = [];
      this.showCityDropdown = false;
    }
  }

  onCityInputBlur() {
    // Delay hiding to allow click on suggestion
    setTimeout(() => {
      this.showCityDropdown = false;
      this.filteredCities = [];
    }, 300);
  }

  info() {
    // Usar la ruta original para obtener la información básica
    this._http.get(environment.Api_info_user).subscribe(
      (data) => {
        this.load = false;
        console.log(data);
        this.specialties = data['specialties:'];

        // Datos del usuario (solo informativos)
        this.shortUpdate.name.setValue(data['user_info']['first_name']);
        this.shortUpdate.name2.setValue(data['user_info']['first_name2']);
        this.shortUpdate.lastname.setValue(data['user_info']['last_name']);
        this.shortUpdate.lastname_2.setValue(data['user_info']['last_name2']);
        this.shortUpdate.email.setValue(data['user_info']['email']);
        this.shortUpdate.cell.setValue(data['user_info']['cell']);
        this.shortUpdate.dni.setValue(data['user_info']['dni']);

        this.cellphone_validate = data['cellphone_validated'];
        this.license = data['medic_info']['profesional_license'];

        // Cargar datos adicionales del perfil médico solo si las ciudades ya están cargadas
        if (this.cities.length > 0) {
          this.loadMedicProfile();
        }
      },
      (error) => {
        console.log(error);
        this.load = false;
      }
    );
  }

  loadMedicProfile() {
    this._http.get(environment.Api_medic_profile_get).subscribe(
      (data: any) => {
        console.log('Additional medic profile data:', data);

        // Datos editables del perfil médico
        this.shortUpdate.gender.setValue(data.gender || '');
        this.shortUpdate.birthdate.setValue(data.birthdate || '');
        this.shortUpdate.address.setValue(data.address || '');
        this.shortUpdate.city.setValue(data.city || '');
        this.shortUpdate.department.setValue(data.department || '');
        this.shortUpdate.workplace.setValue(data.workplace || '');

        // Si hay una ciudad seleccionada, usar los datos disponibles
        if (data.city && data.city_name) {
          // Construir el display con los datos que tienes
          const cityDisplay = data.department ?
            `${data.city_name} - ${data.department}` :
            data.city_name;

          this.citySearchTerm = cityDisplay;

          // Crear un objeto ciudad temporal para referencia
          this.selectedCity = {
            id: data.city,
            dane_id: {
              name: data.city_name,
              department_name: data.department || 'Departamento'
            }
          };

          console.log('Ciudad inicial configurada:', this.citySearchTerm);
        }
      },
      (error) => {
        console.log('Error loading additional profile data:', error);
      }
    );
  }

  setInitialCity(cityId: number) {
    // Buscar la ciudad específica por ID en las ciudades ya cargadas primero
    if (cityId) {
      const city = this.cities.find(c => c.id === cityId);
      if (city) {
        this.selectedCity = city;
        // NO LLENAR EL INPUT AUTOMÁTICAMENTE - Solo guardar la referencia
        // this.citySearchTerm = `${city.dane_id.name} - ${city.dane_id.department_name}`;
        console.log('Ciudad guardada encontrada:', city.dane_id.name);
      } else {
        console.log('Ciudad no encontrada en lista inicial. ID:', cityId);
      }
    }

    // Asegurar que el dropdown esté cerrado y el input vacío al cargar
    this.showCityDropdown = false;
    this.filteredCities = [];
    this.citySearchTerm = ''; // MANTENER EL INPUT VACÍO
  }

  clearCitySearch() {
    this.citySearchTerm = '';
    this.selectedCity = null;
    this.shortUpdate.city.setValue(''); // Limpiar el ID de la ciudad también
    this.showCityDropdown = false;
    this.filteredCities = [];
    this.isSearching = false;

    // Limpiar timeout si existe
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = null;
    }

    console.log('City search cleared');
  }

  updateMedicP() {
    console.log('Form data before submit:', this.update.value);
    console.log('City ID to send:', this.shortUpdate.city.value);
    this.preloader = true;

    if (this.update.valid) {
      // Preparar solo los datos que se pueden actualizar
      const updateData = {
        gender: this.shortUpdate.gender.value,
        birthdate: this.shortUpdate.birthdate.value,
        address: this.shortUpdate.address.value,
        city: this.shortUpdate.city.value, // Este es el ID de la ciudad
        department: this.shortUpdate.department.value, // Ahora es independiente
        workplace: this.shortUpdate.workplace.value
      };

      console.log('Data to send to API:', updateData);

      // Usar el nuevo endpoint para actualizar estos campos específicos
      this._http
        .patch(environment.Api_medic_profile_update, updateData)
        .subscribe(
          (data) => {
            this.preloader = false;
            this.submitted = false;
            this.info(); // Recargar la información
            this.helper.modalSuccess('¡Datos actualizados correctamente!');
            console.log('Update successful:', data);
          },
          (error) => {
            console.log('Update error:', error);
            this.preloader = false;
            this.submitted = false;
            this.helper.modalError(
              this.helper.splitErrorMessages(error.error, '<br>')
            );
          }
        );
    } else {
      this.submitted = true;
      this.preloader = false;
      console.log('Form is invalid:', this.update.errors);
      // Mostrar errores de cada campo
      Object.keys(this.update.controls).forEach(key => {
        const control = this.update.get(key);
        if (control && control.invalid) {
          console.log(`Field ${key} is invalid:`, control.errors);
        }
      });
    }
  }

  ngOnDestroy() {
    // Limpiar timeout al destruir el componente
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = null;
    }
  }

  verifiedSuccess($event) {
    if ($event === true) {
      this.modalRef.hide();
      this.info();
    }
  }
}
